import { render, staticRenderFns } from "./organizationalStructure.vue?vue&type=template&id=50f66bea&scoped=true"
import script from "./organizationalStructure.vue?vue&type=script&lang=js"
export * from "./organizationalStructure.vue?vue&type=script&lang=js"
import style0 from "./organizationalStructure.vue?vue&type=style&index=0&id=50f66bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f66bea",
  null
  
)

export default component.exports